import * as maptilersdk from '@maptiler/sdk';
import { CoordinatesTransformation } from '../utils/CoordinatesTransformation';

export class Actions {
    static showCoordinates() {
        return async (map, coordinates) => {
            const longitude = coordinates.lng;
            const latitude = coordinates.lat;

            const [lv95X, lv95Y] = CoordinatesTransformation.wgs84ToLv95(
                longitude,
                latitude
            );

            const reverseGeocodingResults = await maptilersdk.geocoding.reverse(
                [longitude, latitude],
                { limit: 1 }
            );

            const htmlContent = `
<div>
    <p>
        <b><label for="latlon">Latitude/Longitude, Breite/Länge:</label></b><br>
        <input type="text" id="latlon" value="${Actions._formatLatLong(
            latitude
        )}, ${Actions._formatLatLong(
                longitude
            )}" onClick="this.select();" readonly />
    </p>
    <p>
        <b><label for="lv95">LV95 Schweizer Landeskoordinaten:</label></b><br>
        <input type="text" id="lv95" value="${Actions._formatLv95(
            lv95X
        )}, ${Actions._formatLv95(lv95Y)}" onClick="this.select();" readonly />
    </p>
    ${
        reverseGeocodingResults.features.length > 0
            ? '<p><b>Nächste bekannte Adresse:</b><br>' +
              reverseGeocodingResults.features[0].place_name +
              '</p>'
            : ''
    }
    <p>
        <a href="https://google.ch/maps?q=${latitude},${longitude}" target="_blank">In Google Maps öffnen</a>
    </p>
</div>`;

            new maptilersdk.Popup()
                .setLngLat(coordinates)
                .setHTML(htmlContent)
                .addTo(map);
        };
    }

    static _formatLatLong(number) {
        return number.toFixed(4);
    }

    static _formatLv95(number) {
        const roundedNumber = Math.round(number);
        const numberString = roundedNumber.toString();
        const numberChars = numberString.split('');

        const formattedChars = numberChars.reverse().map((char, index) => {
            return index > 0 && index % 3 === 0 ? `${char}'` : char;
        });

        return formattedChars.reverse().join('');
    }
}
